import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\AccountController::view
 * @see app/Http/Controllers/AccountController.php:340
 * @route '/account/win-loss/view'
 */
export const view = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: view.url(options),
    method: 'post',
})

view.definition = {
    methods: ["post"],
    url: '/account/win-loss/view',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AccountController::view
 * @see app/Http/Controllers/AccountController.php:340
 * @route '/account/win-loss/view'
 */
view.url = (options?: RouteQueryOptions) => {
    return view.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AccountController::view
 * @see app/Http/Controllers/AccountController.php:340
 * @route '/account/win-loss/view'
 */
view.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: view.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AccountController::view
 * @see app/Http/Controllers/AccountController.php:340
 * @route '/account/win-loss/view'
 */
    const viewForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: view.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AccountController::view
 * @see app/Http/Controllers/AccountController.php:340
 * @route '/account/win-loss/view'
 */
        viewForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: view.url(options),
            method: 'post',
        })
    
    view.form = viewForm
/**
* @see \App\Http\Controllers\AccountController::download
 * @see app/Http/Controllers/AccountController.php:371
 * @route '/account/win-loss/{year}/download'
 */
export const download = (args: { year: string | number } | [year: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: download.url(args, options),
    method: 'post',
})

download.definition = {
    methods: ["post"],
    url: '/account/win-loss/{year}/download',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AccountController::download
 * @see app/Http/Controllers/AccountController.php:371
 * @route '/account/win-loss/{year}/download'
 */
download.url = (args: { year: string | number } | [year: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { year: args }
    }

    
    if (Array.isArray(args)) {
        args = {
                    year: args[0],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        year: args.year,
                }

    return download.definition.url
            .replace('{year}', parsedArgs.year.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AccountController::download
 * @see app/Http/Controllers/AccountController.php:371
 * @route '/account/win-loss/{year}/download'
 */
download.post = (args: { year: string | number } | [year: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: download.url(args, options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AccountController::download
 * @see app/Http/Controllers/AccountController.php:371
 * @route '/account/win-loss/{year}/download'
 */
    const downloadForm = (args: { year: string | number } | [year: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: download.url(args, options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AccountController::download
 * @see app/Http/Controllers/AccountController.php:371
 * @route '/account/win-loss/{year}/download'
 */
        downloadForm.post = (args: { year: string | number } | [year: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: download.url(args, options),
            method: 'post',
        })
    
    download.form = downloadForm
const winLoss = {
    view: Object.assign(view, view),
download: Object.assign(download, download),
}

export default winLoss